import React, { useContext, useCallback, memo } from "react";
import clsx from "clsx";

import Skeleton from "components/skeleton";
import RequiredMark from "components/requiredMark";
import ApplicationEntryProgressContext from "components/contexts/applicationEntryProgressContext";

import { generateAutotestValue } from "helpers";

import styles from "./radioButtonValid.module.scss";

const RadioButton = ({
	id,
	className,
	wrapperClassName,
	blurWidth = "65px",
	blurMarginRight = "85px",
	input,
	label,
	disabled,
	meta: { touched, error, warning },
	tabIndex,
	blurLoading,
	requiredMark,
	helperText,
	autoTest = "",
}) => {
	const { triggerSave } = useContext(ApplicationEntryProgressContext);

	const handleBlur = () => {
		input.onBlur(input.value);
		triggerSave?.();
	};

	const hasError =
		!disabled &&
		((touched && error && <p className={styles.spanError}>{error}</p>) ||
			(warning && <p className={styles.spanWarn}>{warning}</p>));

	const radioButton = (
		<div
			className={clsx(styles.wrappRarioButton, wrapperClassName)}
			data-autotest={`radioButton${generateAutotestValue(
				autoTest,
				input.name + label,
			)}`}
		>
			<span className={className}>
				<input
					{...input}
					onBlur={handleBlur}
					onFocus={() => {}}
					disabled={disabled}
					id={id}
					type="radio"
					tabIndex={tabIndex}
				/>
				<label htmlFor={id} className={disabled ? styles.disabled : ""}>
					{label}
					{requiredMark && <RequiredMark />}
					{helperText}
				</label>
			</span>
			{hasError}
		</div>
	);

	const RadioButtonWithLoader = useCallback(
		({ radioButton }) =>
			blurLoading ? (
				<Skeleton
					variant="text"
					width={blurWidth}
					marginRight={blurMarginRight}
				/>
			) : (
				radioButton
			),
		[blurLoading, blurWidth, blurMarginRight],
	);

	return <RadioButtonWithLoader radioButton={radioButton} />;
};

export default memo(RadioButton);
